import React from "react";
import useABC from "../../Provider/TableContext/ABCContext";
import useResponsibility from "../../Provider/TableContext/ResponsibilityContext";
import {  trackException } from "../withApplicationInsight";

export default function useRequirementsAchievementCompute() {
    const { responsibilities, updateResponsibility, loading: responsibilityLoading } = useResponsibility();
    const { abcs, loading: abcLoading } = useABC();
    const loading = React.useMemo(() => abcLoading || responsibilityLoading, [abcLoading, responsibilityLoading]);
    React.useEffect(() => {
        if (loading) return;
        try {
            responsibilities.forEach(responsibility => {
                const achievements = "<div>" + (Array.isArray(responsibility.mcb_ABCResponsibility) ? responsibility.mcb_ABCResponsibility.map(({mcb_abcid}) =>
                    abcs.find(a => a.mcb_abcid === mcb_abcid)
                ).reduce((acc, abc) => acc + abc.mcb_achievementstatement, "") : [] )+ "</div>";
                if (responsibility.mcb_achievementssummary !== achievements) {
                    updateResponsibility({
                        ...responsibility,
                        mcb_achievementssummary: achievements
                    }, false);
                }
                
            });
        } catch (error) {
            trackException({error, properties: {
                context: { responsibilities, abcs },
                relatedTo: "RequirementsAchievement Computation",
            }});
            console.error("Error in useRequirementsAchievementCompute:", error);
        }
    }, [loading, responsibilities, abcs, updateResponsibility]);
}